import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
import messages from '@/language/language'

export default new VueI18n({
    locale: 'jp',
    fallbackLocale: 'jp',
    messages: messages
})